module.exports = __webpack_public_path__ + "img/hartflaechen.fd05477.png";